export const FETCH_SAVE_AREA_TEMPLATE_REQUEST = 'FETCH_SAVE_AREA_TEMPLATE_REQUEST'
export const FETCH_SAVE_AREA_TEMPLATE_SUCCESS = 'FETCH_SAVE_AREA_TEMPLATE_SUCCESS'
export const FETCH_SAVE_AREA_TEMPLATE_FAILURE = 'FETCH_SAVE_AREA_TEMPLATE_FAILURE'
